import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Container = styled.div`
  width: 100%;
  ${mediaQuery('tablet')} {
    padding: 0px;
    width: 100%;
    float: none;
    margin-bottom: 25px;
  }
`;

export const MainImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: min-content;
  border-radius: 10px;
  overflow: hidden;
`;

export const MainImage = styled.div<{ src?: string; aspectRatio?: number }>`
  width: 100%;
  padding-bottom: 75%;
  ${(props) =>
    props.src &&
    css`
      background: url(${props.src}) center center no-repeat;
      background-size: cover;
      cursor: pointer;
    `}

  position: relative;
  -webkit-touch-callout: none;
  -webkit-user-select: none;

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const ThumbnailsContainer = styled.div`
  margin-top: 5px;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  height: 80px;

  & > *:not(:last-child) {
    margin-right: 5px;
  }
`;

export const Thumbnail = styled.div<{ src: string; active: boolean }>`
  background: url(${(props) => props.src}) no-repeat center center;
  overflow: hidden;
  border-radius: 5px;
  background-size: cover;
  flex: 1;
  min-width: 80px;
  max-width: 120px;
  max-height: 80px;
  cursor: pointer;
  opacity: ${(props) => (props.active ? 1 : 0.4)};
  transition: opacity 0.3s ease-in-out;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  &:hover {
    opacity: ${(props) => (props.active ? 1 : 0.7)};
  }
`;

export const ArrowContainer = styled.div<{ right?: boolean }>`
  position: absolute;
  background: linear-gradient(
    ${(props) => (props.right ? 270 : 90)}deg,
    rgba(0, 0, 0, 0.3),
    75%,
    transparent
  );
  padding: 20px;
  bottom: 5px;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => (props.right ? 'right: 0;' : 'left: 0;')};
  font-size: 32px;
  color: white;
  z-index: 2;
  cursor: pointer;
`;
